import dateFnsLocale from 'date-fns/locale/en-US';

export const months = [...Array(12)].map((_, i) => dateFnsLocale.localize.month(i));
export const years = [...Array(110)].map(
  (_, i) => `${new Date(new Date().setFullYear(new Date().getFullYear() + 10)).getFullYear() - i}`
);
